import React, { Component } from "react";
import styled from "styled-components";
import uuid from "uuid/v4";

class Checkbox extends Component {
  state = {
    checked: false
  };

  componentDidMount() {
    this.isControlled = this.props.checked !== undefined;
  }

  handleSelect = e => {
    if (this.isControlled) {
      this.props.onChange(e);
    } else {
      this.setState(prevState => ({ checked: !prevState.checked }));
    }
  };

  render() {
    const uniqueID = uuid();
    const {
      checked: checkedProp,
      onChange,
      name,
      disabled,
      children,
      value,
      className,
      ...props
    } = this.props;
    const checked = checkedProp || this.state.checked;

    return (
      <Label
        htmlFor={uniqueID}
        disabled={disabled}
        // onMouseDown={e => e.preventDefault()}
        className={className}
        {...props}
      >
        <Input
          type="checkbox"
          tabIndex={disabled ? "-1" : "0"}
          onChange={this.handleSelect}
          checked={checked}
          name={name}
          id={uniqueID}
          value={value}
          disabled={disabled}
        />
        <StyledCheckboxSVG focusable="false" viewBox="0 0 23 23">
          <defs>
            <clipPath id="clip-path" transform="translate(1 1)">
              <rect className="cls-1" width="21" height="21" />
            </clipPath>
            <clipPath id="clip-path-2" transform="translate(1 1)">
              <rect className="cls-1" width="68" height="21" />
            </clipPath>
          </defs>
          <g className="cls-2">
            <g className="cls-3">
              <rect className="cls-4" x="1" y="1" width="21" height="21" />
            </g>
          </g>
          {checked && <polyline className="cls-5" points="6.39 10.81 9.51 14.07 15.61 7.54" />}
        </StyledCheckboxSVG>
        <span className="checkbox_span" aria-hidden="true"></span>
        {children}
      </Label>
    );
  }
}

export default Checkbox;

const Label = styled.label`
  position: relative;
  display: inline-block;
  align-items: center;
  cursor: pointer;
  margin: 0 0 0.25rem 1rem;
  padding: 0 0 0 0.75rem;
  line-height: 1.5;

  svg,
  span.checkbox_span {
    bottom: 0;
    height: 21px;
    left: -1rem;
    margin: auto 0;
    position: absolute;
    right: 0;
    top: 0;
    width: 21px;

    ${({ disabled }) => disabled && `stroke: rgb(216, 218, 218);`}
  }

  [type="checkbox"]:focus + svg {
    outline: 1px solid #000;
    outline-offset: -1px;
  }

  [type="checkbox"]:focus ~ span.checkbox_span::after {
    content: "";
    position: absolute;
    top: -2px;
    left: -2px;
    right: -2px;
    bottom: -2px;
    outline: 1px dashed #000;
  }

  ${({ disabled }) => disabled && `color: rgb(216, 218, 218); cursor: default;`}
`;

const Input = styled.input`
  clip: rect(0 0 0 0);
  position: absolute;
  opacity: 0;
  overflow: hidden;
  margin: -0.0625rem;
  padding: 0;
  border: 0;
  white-space: nowrap;
`;

const StyledCheckboxSVG = styled.svg`
  stroke: #000;

  .cls-1,
  .cls-4,
  .cls-5 {
    fill: none;
  }
  .cls-2 {
    fill: red;
    clip-path: url(#clip-path);
  }
  .cls-3 {
    clip-path: url(#clip-path-2);
  }
  .cls-4,
  .cls-5 {
    stroke-miterlimit: 10;
  }
  .cls-4 {
    stroke-width: 2px;
  }
`;
